import type { TourSection } from "./sections"

/** Standalone two-step walkthrough on the demo (mock) checkout page, ported
 *  from the Product Fruits "execute" flow. Not part of the plan checklist —
 *  it replays on every demo checkout visit (no server persistence). */
export const CHECKOUT_TOUR_SECTIONS: TourSection[] = [
  {
    id: "execute",
    label: "Execute",
    steps: [
      {
        page: { kind: "checkout" },
        target: "checkout-summary",
        title: "📋 First month breakdown",
        body: "This section breaks down setup fees and monthly services, giving clients full visibility into what’s included in Month 1.",
        btn: "Continue",
      },
      {
        page: { kind: "checkout" },
        target: "checkout-payment",
        title: "💳 Secure checkout",
        body: "Upon payment, the service markups are paid directly to your Stripe account, and the client will be sent to their Customer Hub to provide any required info and kick off their growth plan.",
        btn: "Almost there",
      },
      {
        page: { kind: "checkout" },
        target: "checkout-confirm",
        action: "click",
        advanceOn: "checkout-pay",
        title: "✍️ Accept and pay",
        body: (
          <>
            Last step: tick <b>I agree to the terms &amp; conditions</b>, then{" "}
            <b>click Confirm &amp; Pay</b> to set the plan live and open the
            client&rsquo;s Customer Hub.
          </>
        ),
      },
    ],
  },
]
